import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacionesService } from '../servicios/notificaciones.service';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.scss']
})
export class NotificacionesComponent implements OnInit {

  @ViewChild('allSelected', { static: true })
  private allSelected!: MatSelectionList;

  user = 'admin';

  listNotifications: any[] = [];
  typeNotifications = 0;

  constructor(
    private NotificationServiceService: NotificacionesService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.activatedRoute.params.subscribe(() => {
      this.user = this.activatedRoute.snapshot.params['id'];
    });
  }

  ngOnInit(): void {
    this.getNotifications(this.user);
  }

  allRead() {
    this.listNotifications.forEach((element) => (element.isRead = true));
  }
  selectAll() {
    this.allSelected.selectAll();
    this.listNotifications.forEach((element) => (element.isRead = true));
  }

  getNotifications(user: string) {
    const step = this.NotificationServiceService.getNotificationsService(
      user
    ).subscribe({
      next: (v) => {
        this.listNotifications = v['result']['list'];
        console.log(this.listNotifications);
        this.listNotifications.forEach(
          (element) => (this.typeNotifications = element.type)
        );
        console.log(this.typeNotifications);
      },
      error: (e) => {
        console.warn(e);
      },
      complete: () => {
        step.unsubscribe();
      },
    });
  }
  markNotificationsAsRead(idNotification: number) {
    const step = this.NotificationServiceService.getMarkNotificationsService(
      4
    ).subscribe({
      next: (v) => {
        console.log(v);
      },
      error: (e) => {
        console.warn(e);
      },
      complete: () => {
        step.unsubscribe();
      },
    });
  }
}
